export default "__VITE_ASSET__JcATdoOZ__"